export default __webpack_public_path__ + "static/media/loc-arte-4.211b4131.webp";